export const NATIVE_NOTIFICATIONS = {
    questionnaireFilled: 'questionnaireFilled',
};
